import { ChatbubbleOutlineIc, CreateOutlineIc } from '@dsch/dd-icons';
import { Link } from 'components/Toolkit/Button/Link';
import * as Styled from 'components/Ratings/AdStats/AdStats.styled';
import type { AdStatsProps } from 'components/Ratings/AdStats/AdStats.typed';

const AdStats = (props: AdStatsProps) => {
  const { avgResponseRate, adCountStats, sellerUrl, isTrader } = props;
  const { activeAdView, lifetimeAdView } = adCountStats || {};

  return (
    <Styled.Container>
      {avgResponseRate && avgResponseRate !== '-' && (
        <Styled.MessageStats>
          <Styled.StatsRow>
            <ChatbubbleOutlineIc height={16} width={16}></ChatbubbleOutlineIc>
            Answers {avgResponseRate} of messages
          </Styled.StatsRow>
        </Styled.MessageStats>
      )}
      {adCountStats && (
        <Styled.AdStats>
          <Styled.StatsRow data-testid={'ad-stats'}>
            <CreateOutlineIc height={16} width={16}></CreateOutlineIc>
            {`${activeAdView?.value} ${activeAdView?.displayText}`}
            <span>|</span>
            {`${lifetimeAdView?.value} ${lifetimeAdView?.displayText} `}
          </Styled.StatsRow>
          {sellerUrl && (
            <Link
              href={sellerUrl}
              ofType="SECONDARY"
              data-tracking="view-all-ads-link"
              rel="nofollow"
              underline
            >
              {isTrader ? 'View our shop' : 'View all ads'}
            </Link>
          )}
        </Styled.AdStats>
      )}
    </Styled.Container>
  );
};

export { AdStats };
